import { useCallback, useState } from 'react';
import { useModal } from 'mui-modal-provider';

import { BirthdayPointsModal } from './birthday-points-modal';
import { INotification, IPointsEdges } from '../../../../../../graphql/app-level-modals/models/get-modals-data.model';
import { getBirthdayPointsNotifications } from '../../utils';
import { getBirthdayPointsEdges } from './utils/get-birthday-points-edges';

export const useBirthdayPointsModal = () => {
  const { showModal } = useModal();
  const [isShow, setIsShow] = useState(true);

  const handleBirthdayPointsModal = useCallback((
    notifications: INotification[], pointsEdges: IPointsEdges, updateNotifications: (notificationId: string) => void,
  ) => {
    const birthdayPointsNotification = getBirthdayPointsNotifications(notifications);
    const birthdayPoints = getBirthdayPointsEdges(pointsEdges);

    if (isShow && birthdayPoints) {
      const { id: notificationId } = birthdayPointsNotification[0];

      showModal(BirthdayPointsModal, {
        notificationId,
        birthdayPoints,
        updateNotifications,
      });
      setIsShow(false);
    }
  }, [showModal, isShow, setIsShow]);

  return { handleBirthdayPointsModal };
};
